__turbopack_context__.v({
  "article": "reset-module-scss-module__kyEQcq__article",
  "aside": "reset-module-scss-module__kyEQcq__aside",
  "base": "reset-module-scss-module__kyEQcq__base",
  "block": "reset-module-scss-module__kyEQcq__block",
  "details": "reset-module-scss-module__kyEQcq__details",
  "div": "reset-module-scss-module__kyEQcq__div",
  "figcaption": "reset-module-scss-module__kyEQcq__figcaption",
  "figure": "reset-module-scss-module__kyEQcq__figure",
  "footer": "reset-module-scss-module__kyEQcq__footer",
  "header": "reset-module-scss-module__kyEQcq__header",
  "hgroup": "reset-module-scss-module__kyEQcq__hgroup",
  "menu": "reset-module-scss-module__kyEQcq__menu",
  "nav": "reset-module-scss-module__kyEQcq__nav",
  "section": "reset-module-scss-module__kyEQcq__section",
});
